import React from 'react'
import { hooks, CDNImage } from '@front/volcanion'
import GeoUtils from '@front/volcanion/utils/geo'

import { TableCell, Box } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Address = ({ address, icon }) => {
  return (
    <Box display='flex' alignItems='center' gap={1}>
      <CDNImage name={icon} category='map' style={{ width: 12, height: 12 }} />
      <TextCell fontSize={13} textAlign='start' value={address} />
    </Box>
  )
}

const Addresses = ({ row }) => {
  const {
    ORDER_LIST_SOURCE_FORMAT,
    ORDER_LIST_DESTINATION_FORMAT
  } = hooks.useRelayConstants(['ORDER_LIST_SOURCE_FORMAT', 'ORDER_LIST_DESTINATION_FORMAT'])

  const source = GeoUtils.getSpecificFormat(row?.source, ORDER_LIST_SOURCE_FORMAT || 'friendly')
  const destination = GeoUtils.getSpecificFormat(row?.destination, ORDER_LIST_DESTINATION_FORMAT || 'friendly')

  return (
    <TableCell padding='none' sx={{ minWidth: 300 }}>
      <Address address={source} icon={'source'} />
      <Address address={destination} icon={'destination'} />
    </TableCell>
  )
}

export default React.memo(Addresses)
